<template>
    <v-row class="ml-1 mr-1 mt-2 mb-2">
        <v-col>
            <v-card>
                <v-row class="ml-1 mr-1">
                        <v-col>
                            <v-autocomplete
                                v-model="lote"
                                :key="lote.id"
                                :items="lotesOrigen"
                                item-text="nombre_lote"
                                item-value="id"
                                label="Seleccione Lote"
                                color="blue darken-3"
                                return-object
                                @change="cargarJumbosLote($event)"
                                dense
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col class="text-center">
                            Bodega Origen
                        </v-col>
                        <v-col>
                            <v-btn class="float-right" small dark color="#1565C0" @click="agregar">
                                <!-- <span>Asignar</span> -->
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                <v-divider></v-divider>
                <v-card-text class="bloque-maxis">
                    <v-row>
                        <v-col>
                            <v-checkbox
                                v-model="checkbox_select"
                                label="Todos"
                                color="#0288D1"
                                class="float-right"
                                hide-details
                                @change="seleccionarTodos"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row v-for="f, idx in fecha_jumbos" :key="idx">
                        <v-col> 
                            <p class="titulo-fecha">{{`FECHA ELABORACION: ${ formatDate(f)  }`}}</p>
                            <v-row> 
                                <v-col v-for="j in jumbos_ordenados.filter(j => j.fecha_elab == f)" :key="j.id" class="ma-0 pa-0">
                                    <v-switch v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card>
                <v-row class="ml-1 mr-1">
                    <v-col>
                        <v-btn small dark color="#1565C0" @click="quitar">
                            <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col><p>Bodega Destino</p></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-text class="bloque-maxis">
                    <v-row v-for="ls in lotesSalientes" :key="ls.id">
                        <v-col>
                            <p class="titulo-fecha">{{`LOTE: ${ls.nombre_lote}`}}</p>
                            <v-row>
                                <v-col v-for="j in ls.jumbos" :key="j.id" class="ma-0 pa-0">
                                    <v-switch :title="formatDate(j.fecha_elab)" v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h3>Total Kilos: {{ kilos }}</h3>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            
        </v-col>
    </v-row>
</template>

<script>
    import { mapState,mapMutations } from 'vuex'
    import moment from 'moment'

    export default{
        props:{
            lotesOrigen: {
                type: Array,
                required: true
            },
            bodegaOrigen: {
                type: Number,
                required: true
            },
            loteSelected: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                jumbos: [],
                fecha_jumbos: [],
                lote: {id:''},
                jumbos_repaso: [],
                checkbox_select: false,
            }
        },
        methods : {
            async cargarJumbosLote(event){
                this.mostrarLoading({titulo:'Cargando Maxisacos...',color:'green'})
                this.lote.id = event.id

                if ((this.lote.id) && this.bodegaOrigen) {
                    let url = `${this.base_url}jumbos/maxisacos/disponibles/${this.lote.id}/${this.bodegaOrigen}`;
                    await this.axios.get(url,this.headers).then((res)=>{
                        this.fecha_jumbos = [...new Set(res.data.map(j => j.fecha_elab))];
                        this.jumbos = res.data;
                        this.ocultarLoading();
                    }).catch((error)=>{
                        console.log('error',error);
                        this.ocultarLoading();
                    });
                } else {
                    this.ocultarLoading();
                }
            },

            async agregar(){
                let agregar = this.jumbos.filter(j => j.switch == true);

                let restantes = this.jumbos.filter(j => j.switch != true);
                let index_lote = this.lotesOrigen.findIndex(l => l.id == this.lote.id);
                this.$set(this.lotesOrigen[index_lote], 'maxisacos', restantes);
                this.jumbos = restantes;
                this.jumbos_repaso = this.jumbos_repaso.concat(agregar);
                this.checkbox_select = false;
            },

            async quitar(){
                /**los id de los que se van a quitar */
                let ids = this.jumbos_agregados.filter(j=>j.switch == false).map(
                    j => j.id
                );
                let jumbos_quitar = this.jumbos_repaso.filter( j => {
                    return ids.includes(j.id);
                });
                /**seteando en falso la seleccion */
                jumbos_quitar.forEach(j => {
                    j.switch = false;
                });
                /**conservar los jumbos del lote actual */
                let jumbos_lote = jumbos_quitar.filter(j => j.lotes_id == this.lote.id);
                this.jumbos = this.jumbos.concat(jumbos_lote);
                this.jumbos_repaso = this.jumbos_repaso.filter(j => {
                    return !ids.includes(j.id);
                });
                
            },
            seleccionarTodos(){
                if(this.checkbox_select){
                    this.jumbos.forEach(j => {
                        j.switch = true;
                    });
                }else{
                    this.jumbos.forEach(j => {
                        j.switch = false;
                    });
                }
            },
            seleccionarTodosLote($event,id){
                let index = this.lotesSalientes.findIndex(l=> l.id == id);
                this.jumbos_repaso.forEach((j,index)=>{
                    if(j.lotes_id == id){
                        this.$set(this.jumbos_repaso[index],'switch',$event);
                    }
                });
            },
            limpiar(){
                this.lote = {id:''};
                this.jumbos_repaso = [];
                this.jumbos = [];
            },
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('DD-MM-YYYY')
                }
            },
            ...mapMutations(['mostrarLoading', 'ocultarLoading']),
        },
        computed : {
            lotesSalientes(){
                /**retorna el id y nombre de los lotes distintos */
                let lotes = Array.from( new Set(this.jumbos_repaso.map(j=>j.lotes_id)))
                        .map(id => {
                            return{
                                id:id,
                                todos:true,
                                nombre_lote: this.lotesOrigen.find(l => l.id === id).nombre_lote,
                                jumbos: this.jumbos_repaso.filter(j => j.lotes_id == id).map(
                                    j => {
                                        return {
                                            id:j.id,
                                            nro_jumbo:j.nro_jumbo,
                                            lotes_id:j.lotes_id,
                                            peso:j.peso,
                                            fecha_elab:j.fecha_elab,
                                            switch:j.switch
                                        }
                                    }
                                ).sort((a,b)=>a.nro_jumbo - b.nro_jumbo)
                            }
                        });
                // console.log("lotes", lotes, "jumbos_repaso", this.jumbos_repaso)

                this.$emit('lotes-salientes', lotes)
                return lotes;
            },

            jumbos_agregados(){
                let jbs = [];
                this.lotesSalientes.forEach(l => {
                    l.jumbos.forEach(j => {
                        jbs.push(j)
                    });
                });
                return jbs;
            },

            kilos(){
                return this.jumbos_repaso.reduce((suma_parcial, valor) => suma_parcial + valor.peso,0);
            },

            jumbos_ordenados(){
                return this.jumbos = this.jumbos.sort((a, b) => a.nro_jumbo - b.nro_jumbo);
            },

            ...mapState(['base_url','headers']),
        },
        components :{

        },

    }

</script>

<style scoped>
    .titulo-fecha {
        font-size: 14px;
        font-weight: bold;
        color: #2c3e50;
        margin-bottom: 20px;
        margin-top: 20px;
    }
    .bloque-maxis {
        background-color: #f2f2f2;
        border-radius: 5px;
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
        margin-bottom: 20px;
        padding: 30px;
    }
</style>